import React from 'react'
import { useSelector } from 'react-redux'
import { Badge } from 'react-bootstrap'
import { getDailyCharity } from '../selectors/getDailyCharity'
import { categoryColor } from '../utils/categoryColor'

function CharitySpotlight({ date }) {
  const charities = useSelector((state) => state.charities.items ?? [])
  const loading = useSelector((state) => state.charities.loading)
  const charity = charities.length > 0 ? getDailyCharity(charities, date) : null

  if (loading) {
    return (
      <article aria-label="Loading charity" className="py-4">
        <p className="text-uppercase fw-semibold text-muted mb-1" style={{ fontSize: '0.7rem', letterSpacing: '0.1em' }}>
          Charity Spotlight
        </p>
        <div className="text-muted fst-italic">Loading&hellip;</div>
      </article>
    )
  }

  if (charities.length === 0) {
    return (
      <article aria-label="Charity Spotlight" className="py-4">
        <p className="text-uppercase fw-semibold text-muted mb-1" style={{ fontSize: '0.7rem', letterSpacing: '0.1em' }}>
          Charity Spotlight
        </p>
        <p className="text-muted fst-italic">Check back soon.</p>
      </article>
    )
  }

  if (!charity) return null

  const { name, url, description, logoUrl, category } = charity.data

  return (
    <article aria-label="Charity Spotlight" className="py-4">
      <header className="mb-4">
        <p
          className="text-uppercase fw-semibold text-muted mb-1"
          style={{ fontSize: '0.7rem', letterSpacing: '0.1em' }}
        >
          Charity Spotlight
        </p>
        <p className="text-muted fst-italic mb-3" style={{ lineHeight: '1.7' }}>
          Every day a different organization. These are causes I believe in — groups doing
          real work in the world. If one moves you, click through.
        </p>
        {logoUrl && (
          <img src={logoUrl} alt={name} className="mb-3" style={{ maxHeight: '60px' }} />
        )}
        <h2 className="fw-bold mb-1">{name}</h2>
        <Badge bg={categoryColor(category)} className="fw-normal">
          {category}
        </Badge>
        <hr className="opacity-25 mt-3" />
      </header>

      <p className="mb-4" style={{ lineHeight: '1.7' }}>
        {description}
      </p>

      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-outline-secondary btn-sm"
      >
        Visit {name}{' '}
        <svg
          aria-label="external link"
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          fill="currentColor"
          viewBox="0 0 16 16"
        >
          <path fillRule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z" />
          <path fillRule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z" />
        </svg>
      </a>
    </article>
  )
}

export default CharitySpotlight
